module.exports = __webpack_public_path__ + "img/gift.bfb74b9e.png";